import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Image / Illustration */}
        <img
          src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
          alt="404"
          style={styles.image}
        />

        {/* Heading */}
        <h1 style={styles.title}>Oops! Page Not Found</h1>

        {/* Sub Text */}
        <p style={styles.text}>
          Looks like the page you’re looking for doesn’t exist or has been
          moved.
        </p>

        {/* Buttons */}
        <div style={styles.buttonGroup}>
          <Link to="/" style={styles.primaryBtn}>
            🏠 Go Home
          </Link>

          <Link to="/category/residential" style={styles.secondaryBtn}>
            🛒 Shop Now
          </Link>
        </div>

        {/* Extra Links */}
        <div style={styles.links}>
          <Link to="/contactus">Contact Support</Link>
          <Link to="/aboutus">About Us</Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8f9fb",
    padding: "20px",
  },
  card: {
    textAlign: "center",
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
    maxWidth: "400px",
    width: "100%",
  },
  image: {
    width: "120px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  text: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "25px",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    marginBottom: "20px",
  },
  primaryBtn: {
    background: "#ff6a00",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "bold",
  },
  secondaryBtn: {
    background: "#007bff",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "bold",
  },
  links: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "13px",
  },
};

export default NotFound;
